import Vue from 'vue'
import Router from 'vue-router'
import Routes from '@/data/routes.json'
import RootView from '@/components/views/RootView'

Vue.use(Router)

export function createRouter (store) {
  function route (path, view, fullscreen, props, children) {
    const hasChildren = Array.isArray(children)

    return {
      path: path,
      meta: { fullscreen },
      name: hasChildren ? undefined : view,
      props,
      component: () => import(`@/pages/${view}Page.vue`),
      children: hasChildren
        ? children.map(r => route(
          r.route,
          r.page,
          r.fullscreen,
          r.props,
          r.children
        ))
        : []
    }
  }

  const routes = Routes.map(r => route(
    r.route,
    r.page,
    r.fullscreen,
    r.props,
    r.children
  ))

  routes.unshift({
    path: '/',
    name: 'home/Home',
    meta: { fullscreen: true },
    component: () => import(
      /* webpackChunkName: "home" */
      '@/pages/home/HomePage.vue'
    )
  })

  const router = new Router({
    routes: [
      { path: '', component: RootView, children: routes },
      { path: '/login', name: 'Login', component: () => import(`@/pages/LoginPage.vue`) },
      { path: '/inscripciones/especialidad', name: 'inscripciones/Especialidad', component: () => import(`@/pages/inscripciones/EspecialidadPage.vue`) }
    ]
  })

  router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters['isAuthenticated']

    if (to.meta.fullscreen || from.meta.fullscreen) {
      // store.commit('app/FULLSCREEN', !!to.meta.fullscreen)
    }

    if (to.name === 'inscripciones/Reinscripcion' && isAuthenticated) {
      const profile = store.getters['getProfile']
      if (profile.semestre >= profile.semestreEspecialidad && !profile.especialidad) {
        next('/inscripciones/especialidad')
      }
    }

    if (to.path !== '/login' && !isAuthenticated) {
      next('/login')
    } else {
      next()
    }
  })

  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js